import type { SvgComponent } from '@/types/SvgComponent';

/**
 * `.icon.modifier.plus.large` from the Weave DS migration file — an 11px box holding a 5px mark
 * with a 1px stroke, as the "Runs counter" design specifies for the stepper controls.
 *
 * See {@link ModifierMinusLargeIcon} for why this is a local glyph rather than an `@figma/fpl-icons`
 * import.
 */
export const ModifierPlusLargeIcon: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <path
        d="M5.5 3C5.77614 3 6 3.22386 6 3.5V5H7.5C7.77614 5 8 5.22386 8 5.5C8 5.77614 7.77614 6 7.5 6H6V7.5C6 7.77614 5.77614 8 5.5 8C5.22386 8 5 7.77614 5 7.5V6H3.5C3.22386 6 3 5.77614 3 5.5C3 5.22386 3.22386 5 3.5 5H5V3.5C5 3.22386 5.22386 3 5.5 3Z"
        fill="var(--fpl-icon-color, var(--color-icon))"
      />
    </svg>
  );
};
